import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_UTIL } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import ReportHwEntity from '../../../../../entity/ReportHwEntity';
import __ from 'lodash';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import logo_exam from '../../homework/images/banner_homework_report_detail.png';


class RekapExamDetail extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            dialogShow: false,
            alertShow: false,
            alertMessage: '',
            idAdmin: null,
            idSekolah: null,
            namaSekolah: null,
            dataKelas: null,
            dataSubProfil: [],
            dataGuru: {},
            dataAllSiswa: [],
            dataKunciJawaban: [],
            detailJawaban: [],
        };
    }

    async componentDidMount() {
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        console.groupCollapsed('componentDidMount');
        console.info('CEK ACCOUNT', this.props.account);
        console.info('PARAM 1',  this.props.match.params.idJadwal);
        console.info('PARAM 2',  this.props.match.params.idProfil);
        console.info('PARAM 3',  this.props.match.params.idKp);
        console.info('PARAM 4',  this.props.match.params.ta1);
        console.info('PARAM 5',  this.props.match.params.ta2);
        console.groupEnd();
        
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                idAdmin: this.props.account.idAdmin,
                idSekolah: this.props.account.idSekolah,
                namaSekolah: this.props.account.namaUser,
            });

            // Fetch Report Exam Detail
            const fetchReportExamDetail = await accountManagement.post(CONFIG.REKAP_EXAM_DETAIL, {
                ['idProfil']: this.props.match.params.idProfil,
                ['idJadwal']: this.props.match.params.idJadwal,
                ['idKelasParalel']: this.props.match.params.idKelasParalel,
                ['tahunAjaran']: this.props.match.params.ta1 + '/' + this.props.match.params.ta2
            })
            .catch(function(error) {
                console.error('Error fetchReportExamDetail', error);
            });
            console.info('Response fetchReportExamDetail', fetchReportExamDetail);

            // Set State Report Exam Detail
            if(fetchReportExamDetail.request.readyState === 4 && fetchReportExamDetail.status === 200) {
                console.info('CEK fetchReportExamDetail', fetchReportExamDetail);
                if(fetchReportExamDetail.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataKelas: fetchReportExamDetail.data.data.dataKelas,
                        dataSubProfil: fetchReportExamDetail.data.data.dataSubProfil,
                        // dataGuru: fetchReportExamDetail.data.data.dataGuru,
                        dataAllSiswa: fetchReportExamDetail.data.data.dataSiswa,
                        dataKunciJawaban: fetchReportExamDetail.data.data.dataKunciJawaban,
                        detailJawaban: fetchReportExamDetail.data.data.detailJawaban,
                    });
                }
            }
        }

        this.setState({
            isFetching: false
        });
        console.timeEnd("Time componentDidMount");
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }

    showAlert = () => {
        if(this.state.alertShow) {
            return(
                <Alert severity="info"
                    action={
                        <IconButton aria-label="close" color="inherit" size="small" onClick={() => this.setState({ alertShow: false })}>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </IconButton>
                    }
                    >
                    <strong>{ this.state.alertMessage }</strong>
                </Alert>
            )
        }
    }
    
    renderHeadKunciJawaban() {
        var lisNumberColspan = [];
        let number = Math.max.apply(Math, this.state.dataSubProfil.map(function(o) { return o.jumlahSoal; }));
        
        for (var i=1; i<=number; i++) {
            lisNumberColspan.push(<th key={i} className="th-title v-align-center" scope="col">{ i }</th>);
        }

        return (
            <thead>
                <tr>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">#</th>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">KUNCI JAWABAN</th>
                    <th className="th-title v-align-center" scope="col" colSpan={ number }>ITEM SOAL</th>
                </tr>
                <tr>
                    {lisNumberColspan}
                </tr>
            </thead>
        )
    }

    renderBodyKunciJawaban() {
        return (
            <tbody>
                {
                    this.state.dataSubProfil.map((itemSubProfil, indexSubProfil) => {
                        return (
                            <tr key={indexSubProfil}>
                                <td className="text-body center">{indexSubProfil + 1}</td>
                                <td className="text-body left">{itemSubProfil.nama}</td>
                                {
                                    this.state.dataKunciJawaban.map((itemKunci, indexKunci) => {
                                        if(itemKunci.ID_SUB_PROFIL_CBT === itemSubProfil.idSubProfilCbt.toString()) {
                                            if(itemKunci.KUNCI_JAWABAN === "1") {
                                                return (
                                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>A</td>
                                                )
                                            }
                                            else if (itemKunci.KUNCI_JAWABAN === "2") {
                                                return (
                                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>B</td>
                                                )
                                            }
                                            else if (itemKunci.KUNCI_JAWABAN === "3") {
                                                return (
                                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>C</td>
                                                )
                                            }
                                            else if (itemKunci.KUNCI_JAWABAN === "4") {
                                                return (
                                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>D</td>
                                                )
                                            }
                                            else {
                                                return (
                                                    <td key={itemKunci.ID_BANK_SOAL} className="text-body center" data-attr-id={itemKunci.ID_BANK_SOAL}>E</td>
                                                )
                                            }
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        );
    }
    
    renderHeadJawabanSiswa(jumlah) {
        var lisNumberHeadJawabanSiswa = []
        for (var i=1; i<=jumlah; i++) {
            lisNumberHeadJawabanSiswa.push(<th key={i} className="th-title v-align-center" scope="col">{ i }</th>);
        }

        return (
            <thead>
                <tr>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">No</th>
                    <th className="th-title v-align-center" scope="col" rowSpan="2">NAMA SISWA</th>
                    <th className="th-title v-align-center" scope="col" colSpan={ jumlah }>ITEM SOAL</th>
                </tr>
                <tr>
                    { lisNumberHeadJawabanSiswa }
                </tr>
            </thead>
        )
    }

    renderBodyJawabanSiswa(id) {
        return(
            <tbody>
                {
                    this.state.dataAllSiswa.map((itemSiswa, indexSiswa) => {
                        return (
                            <tr key={indexSiswa}>
                                <td className="styles.text-body center" >{ indexSiswa + 1 }</td>
                                <td className="styles.text-body left" >{ itemSiswa.NAMA_SISWA}</td>
                                {
                                    this.state.detailJawaban.map((itemJawaban, indexJawaban) => {
                                        if(parseInt(itemJawaban.ID_SUB_PROFIL_CBT) === id && itemJawaban.ID_SISWA === itemSiswa.ID_SISWA) {
                                            if(itemJawaban.JAWABAN_SISWA === "1") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>A</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "2") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>B</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "3") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>C</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "4") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>D</td>
                                                )
                                            }
                                            else if (itemJawaban.JAWABAN_SISWA === "5") {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>E</td>
                                                )
                                            }
                                            else {
                                                return (
                                                    <td key={indexJawaban} className={itemJawaban.STATUS_JAWABAN === '1' ? 'text-body center green' : 'text-body center red'} data-attr-id={itemJawaban.ID_BANK_SOAL} style={{ textAlign: 'center' }}>-</td>
                                                )
                                            }
                                        }
                                    })
                                }
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    render() {
        require('../../homework/homeworkReport.css');

        console.groupCollapsed('CEK State/Props RekapExamDetail');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        return(
            <div className="page">
                <LoaderModal isFetching={this.state.isFetching}/>

                <div className="null" style={{ paddingBottom: '50px' }}>
                    <div className="row">
                        <div className="col-md-12">
                            <img src={logo_exam} width="100%"></img>
                        </div>
                    </div>
                    
                    <br></br>
                    <hr/>
                    <div className="row">
                        <div className="col-md-4 header-title-text left">NAMA JADWAL { this.state.dataSubProfil.namaSubProfil }</div>

                        <div className="col-md-4 header-title-text center">KELAS { this.state.dataKelas }, { this.state.namaSekolah }</div>

                        {/*
                        <div className="col-md-4 header-title-text right">NAMA GURU { this.state.dataGuru.NAMA_GURU }</div>
                        */}
                    </div>
                    <hr/>

                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-custom">
                                { this.renderHeadKunciJawaban() }

                                { this.renderBodyKunciJawaban() }
                            </table>

                        </div>
                    </div>

                    {
                        this.state.dataSubProfil.map((itemSubProfil, indexSubProfil) => {
                            return (
                                <div key={indexSubProfil} className="row">
                                    <div className="col-md-12">
                                        <h5>{ itemSubProfil.nama }</h5>
                                        
                                        <table className="table table-custom">
                                            { this.renderHeadJawabanSiswa(itemSubProfil.jumlahSoal) }

                                            { this.renderBodyJawabanSiswa(itemSubProfil.idSubProfilCbt) }
                                        </table>
                                    </div>
                                </div>
                            )
                        })
                    }
                        
                    <div className="row footer-text">
                        <div className="col-md-12">
                            <br/>
                        </div>
                        
                        <div className="col-md-3">
                            JUMLAH SISWA
                        </div>

                        <div className="col-md-9">
                            { this.state.dataAllSiswa.length }
                        </div>
                    </div>

                    
                    {
                        this.state.dataSubProfil.map((itemSubProfil, indexSubProfil) => {
                            return (
                                <div key={indexSubProfil} className="row footer-text">
                                    <div className="col-md-3">
                                        JUMLAH SOAL {itemSubProfil.nama}
                                    </div>

                                    <div className="col-md-9">
                                        { itemSubProfil.jumlahSoal }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                <div className="fixed_button">
                    <button className="btn btn-outline-dark btn133w pull-right" style={{marginRight:'1em'}} onClick={() => window.print()}>Print</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(RekapExamDetail);